module.exports = __webpack_public_path__ + "img/ir.33b7bde8.svg";